import ApiService from "../../../utils/api.service";
export default {
  get (context, params) {
    return new Promise((resolve, reject) => {
      ApiService.get('billing/invoice/' + params)
        .then(({ data }) => {
          context.commit('setInvoice', data)
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  pdf (_context, params) {
    return new Promise((resolve, reject) => {
      ApiService.get('billing/invoice/' + params + '/print')
        .then(({ data }) => {
          resolve(data)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  payout (context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post('billing/invoice/' + params.hash + '/payout', params)
        .then(({ data }) => {
          context.commit('setInvoice', data)
          resolve(data)
        }).catch((error) => {
          reject(error.response)
        })
    })
  },
  setupPayment (context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post('billing/invoice/' + params.hash + '/setup-payment', params)
        .then(({ data }) => {
          // context.commit('setInvoice', data)
          resolve(data)
        }).catch((error) => {
          reject(error.response)
        })
    })
  },

  enrollPayment (context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post('billing/invoice/' + params.hash + '/enroll', params)
        .then(({ data }) => {
          // context.commit('setInvoice', data)
          resolve(data)
        }).catch((error) => {
          reject(error.response)
        })
    })
  },

  checkPayout (context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post('billing/invoice/' + params.hash + '/check-payout', params)
        .then(({ data }) => {
          // context.commit('setInvoice', data)
          resolve(data)
        }).catch((error) => {
          reject(error.response)
        })
    })
  }
}
